// Converts from degrees to radians.
Math.radians = function(degrees) {
    return degrees * Math.PI / 180;
  };
   
// Converts from radians to degrees.
Math.degrees = function(radians) {
return radians * 180 / Math.PI;
};

export default class Auflager{
    /**
     * Klasse für Auflager
     * Es ist Grundsätzlich angedacht, dass die Auflager auch Federsteifigkeiten haben können. 
     * In diesem Fall werden für die Werte nicht 0 sondern die entsprechenden Federsteifigkeiten angegeben.
     * für starre Auflager werden die Werte auf -1 gesetzt.
     * 
     * Es muss noch die Verarbeitung für gedrehte Auflager ergänzt werden, das ist hauptsächlich in der berechnung.js zu erledigen. 
     * 
     * Notiz: Evtl. bei Erstellung eines neuen Systems immer gleich Standardauflager erstellen?
     * @param {Auflagerliste} list Liste der Auflager
     * @param {Number} cX Federsteifigkeit in x-Richtung, 0 = frei, -1 = starr
     * @param {Number} cY Federsteifigkeit in y-Richtung, 0 = frei, -1 = starr
     * @param {Number} cM Drehfedersteifigkeit, 0 = frei, -1 = starr
     * @param {Number} Winkel_degrees Auflagerverdrehung in Grad
     */
    constructor(list, cX, cY, cM, Winkel_degrees){
        this.Werte = [cX,cY,cM]
        this.Winkel = Math.radians(Winkel_degrees) || 0
        this.Knotenliste = []
        this.list = list || null
    }
    get number() {
        if(this.list) return this.list.indexOf(this)+1
        else return null
    }
    get name() { return 'Auflager Nr.' + this.number}
    get info() { return this.name+ ' cX:' +this.Werte[0]+ '; cY:' +this.Werte[1]+ '; cM:' +this.Werte[2]}
    get xWert() { return this.Werte[0] }
    set xWert(v) {this.Werte[0] = v}
    get yWert() { return this.Werte[1] }
    set yWert(v) {this.Werte[1] = v}
    get mWert() { return this.Werte[2] }
    set mWert(v) {this.Werte[2] = v}        
    get Winkel_Degree(){ return Math.degrees(this.Winkel) }
    set Winkel_Degree(value){ this.Winkel = Math.radians(value) }
    add_Knotenverknüpfung(knoten){this.Knotenliste.push(knoten)}
    delete_Knotenverknüpfung(knoten){
        if (this.Knotenliste.indexOf(knoten) ==-1) return console.log('Knoten nicht in Liste')
        this.Knotenliste.splice(this.Knotenliste.indexOf(knoten),1)}
}
